module.exports = __webpack_public_path__ + "img/winterhawk4.89ce7166.png";